import {PropsWithChildren} from "react";
import {CreateKycProvider} from ".";

export function CreateKycContextWrapper({children}: PropsWithChildren) {
  return <CreateKycProvider>{children}</CreateKycProvider>;
}
